import axios from "axios";
import Cookies from "js-cookie";
import error from "utils/Notifications/Error";

export const pathname = process.env.REACT_APP_BASE_API || "";

export const instance = axios.create({
  baseURL: pathname,
});

export const patchInstance = axios.create({
  baseURL: pathname,
  method: "PATCH",
});


instance.interceptors.request.use((config) => {
  if (Cookies.get("access")) {
    config.headers.Authorization = `Bearer ${Cookies.get("access")}`;
  }
  return config;
});

patchInstance.interceptors.request.use((config) => {
  if (Cookies.get("access")) {
    config.headers.Authorization = `Bearer ${Cookies.get("access")}`;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  async (err) => {
    if (!err.response) {
      error("Нет соединения с сервером");
      return Promise.reject(err);
    }

    const status = err.response.status;
    const urlParts = err.request?.responseURL?.split("/") || [];
    const apiName = urlParts[urlParts.length - 1] || "api";

    switch (status) {
      case 401:
        if (err.request.responseURL.includes("auth") && window.location.href.includes("login")) {
          error("Неправильный логин или пароль");
        } else {
          error(`${apiName}: ${err.message}`);
        }
        Cookies.remove("access");
        break;

      case 400:
        if (apiName.includes("save_logs")) {
          error("Не удалось сохранить логи");
        } else if (window.location.href.includes("login")) {
          error("Неправильный логин или пароль");
        }
        break;

      case 409:
        break;

      default:
        error(`${apiName}: ${err.message}`);
        break;
    }

    return Promise.reject(err);
  }
);
instance.interceptors.request.use((config) => {
  const robotId = localStorage.getItem("selectedRobotId");

  if (robotId && !config.url?.includes("/robots")) {

    config.params = {
      ...(config.params || {}),
      robot_id: robotId,
    };
  }

  return config;
}, (error) => Promise.reject(error));

patchInstance.interceptors.request.use((config) => {
  const robotId = localStorage.getItem("selectedRobotId");

  if (robotId && !config.url?.includes("/robots")) {
    config.params = {
      ...(config.params || {}),
      robot_id: robotId,
    };
  }

  return config;
}, (error) => Promise.reject(error));
export default instance;

